import React, { useContext } from 'react';
import { Route, Routes } from 'react-router';
import { AuthContext } from './common/contexts/authContext';

import AccesValidator from './AccesValidator';
import routes from './common/routes/routes';
import { CommonDataProvider } from './common/contexts/commonDataContext';
import Loading from './common/components/Loading';

function App() {
	const { authUser } = useContext(AuthContext);

	if (authUser === undefined) {
		return <Loading />;
	}

	return (
		<>
			{authUser && <AccesValidator />}
			<Routes>
				{routes.map((route) => (
					<Route
						key={route.path}
						path={route.path}
						element={
							route.dont_require_auth ? (
								route.element
							) : (
								<React.Fragment>
									<CommonDataProvider>{route.element}</CommonDataProvider>
								</React.Fragment>
							)
						}
					/>
				))}
			</Routes>
		</>
	);
}

export default App;
